import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

import { CycleProductionPage } from "../../../../areas/admin/cycle/CycleView";

/**
 * "Ciclo diario" (FE-14 FR-FE14-08..12). The run form is a dev-only screen (FE-01 FR-FE01-31):
 * Vite replaces `import.meta.env.VITE_ENV` at build time, so in production the lazy import is dead
 * code and its chunk is never emitted (scripts/check-bundle.mjs). Production renders the
 * read-only schedule and last runs (FR-FE14-11, AC-03).
 */
const CyclePage = /* @__PURE__ */ lazy(() => import("../../../../areas/admin/cycle/dev/CyclePage"));

export const Route = createFileRoute("/app/_seller/admin/cycle")({
  component: CycleRoute,
});

function CycleRoute() {
  return import.meta.env.VITE_ENV === "production" ? <CycleProductionPage /> : <CyclePage />;
}
